import { Route, Routes, useLocation } from 'react-router-dom';
import { ButtonLink, Col, Row, Text } from '../../common/components';
import { APP_URL, isDemo } from '../../common/constants/common';
import routes from '../../common/constants/routes';
import { useDocumentTitle } from '../../common/hooks';
import { t } from '../../common/i18n';
import { PageError } from '../../System/PageError';

import { BuildingSearch } from './01BuildingSearch';
import { BuildingConfirm } from './02BuildingConfirm';
import { LegalEntity } from './03LegalEntity';
import { User } from './04User';
import { Summary } from './05Summary';

export const AdminRegistrationRouter: React.FC = () => {
  useDocumentTitle(t('AdminRegistration.title'));
  const location = useLocation();

  // Demo nesmí zakládat domy (adresa by se dala zkopírovat z produkce) — platí i pro přímou URL
  if (isDemo) {
    return (
      <div className="OnboardingForm">
        <Row>
          <Col className="mb-2">
            <Text size="h1">{t('App.demoRegistration.heading')}</Text>
          </Col>
        </Row>
        <Row>
          <Col className="mb-4">
            <Text size="body-medium" color="Neutral700">
              {t('App.demoRegistration.text')}
            </Text>
          </Col>
        </Row>
        <Row>
          <Col className="mb-2">
            <ButtonLink external to={`${APP_URL}${routes.registration}`} title={t('App.demoRegistration.toApp')} />
          </Col>
        </Row>
        <Row>
          <Col className="mb-2">
            <ButtonLink variant="secondary" to={routes.root} title={t('App.demoRegistration.back')} />
          </Col>
        </Row>
      </div>
    );
  }

  return (
    <Routes>
      <Route index element={<BuildingSearch />} />
      <Route path="building-confirm" element={<BuildingConfirm state={location.state} />} />
      <Route path="legal-entity" element={<LegalEntity state={location.state} />} />
      <Route path="user" element={<User state={location.state} />} />
      <Route path="summary" element={<Summary state={location.state} />} />

      <Route path="*" element={<PageError code="404" />} />
    </Routes>
  );
};

export default AdminRegistrationRouter;
